import { FC } from 'react'
import {
    SearchInputWrapper,
    Input,
    SearchIconWrapper,
} from './SearchInput.styles'
import SearchIcon from '@assets/images/search-icon-left.svg?react'
import { useCustomTheme } from '@/core/theme'

interface SearchInputProps {
    value: string
    placeholder?: string
    onChange: (value: string) => void
    id?: string
    dataTestId?: string
    width?: string
    inputHeight?: string
    className?: string
}

const SearchInput: FC<SearchInputProps> = ({
    value,
    placeholder,
    onChange,
    id,
    dataTestId,
    width,
    inputHeight,
    className,
}) => {
    const theme = useCustomTheme()
    return (
        <SearchInputWrapper className={className}>
            <SearchIconWrapper>
                <SearchIcon
                    color={theme.colors.greys[500]}
                    width={14}
                    height={14}
                />
            </SearchIconWrapper>
            <Input
                id={id}
                type="text"
                value={value}
                placeholder={placeholder}
                onChange={(e) => onChange(e.target.value)}
                data-testid={dataTestId || 'search-input'}
                width={width}
                inputHeight={inputHeight}
            />
        </SearchInputWrapper>
    )
}

export default SearchInput
